import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LatarBelakang from './components/LatarBelakang';
import Programs from './components/Programs';
import TargetLembaga from './components/TargetLembaga';
import ShowcaseLembaga from './components/ShowcaseLembaga';
import TabunganQurban from './components/TabunganQurban';
import WakafProduktif from './components/WakafProduktif';
import Kontak from './components/Kontak';
import { CTA, Footer } from './components/CTAFooter';

export default function App() {
  const [lottieData, setLottieData] = useState(null);

  useEffect(() => {
    fetch('/lottie-ramadan.json')
      .then(r => r.json())
      .then(data => setLottieData(data))
      .catch(() => console.warn('Lottie file not found'));
  }, []);

  // Responsive styles injected once
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @media (max-width: 900px) {
        section[id="hero"] { grid-template-columns: 1fr !important; padding-top: 7rem !important; }
        .hero-right { display: none !important; }
      }
      @media (max-width: 768px) {
        .two-col { grid-template-columns: 1fr !important; gap: 2rem !important; }
        .three-col { grid-template-columns: 1fr 1fr !important; }
        .prog-pane-grid { grid-template-columns: 1fr !important; }
      }
      @media (max-width: 520px) {
        .three-col { grid-template-columns: 1fr !important; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <div>
      <Navbar />
      <Hero lottieData={lottieData} />
      <LatarBelakang />
      <Programs />
      <TargetLembaga />
      <ShowcaseLembaga />
      <TabunganQurban />
      <WakafProduktif />
      <Kontak />
      <CTA />
      <Footer />
    </div>
  );
}
